import React from 'react'
import { connect } from 'react-redux'
import { selectDeviceTypeIsMobile } from 'selectors/app'
import { doDeleteFile } from 'actions/attachments'
import MobileAttachment from './Mobile'
import DesktopAttachment from './Desktop'

const select = state => ({
  deviceTypeIsMobile: selectDeviceTypeIsMobile(state),
})

const perform = {
  doDeleteFile,
}

const Attachment = props => {
  const { deviceTypeIsMobile } = props

  if (!deviceTypeIsMobile) return <DesktopAttachment {...props} />

  return <MobileAttachment {...props} />
}

export default connect(select, perform)(Attachment)
